<template>
  <div>
    <!-- <a-row :gutter="30" style="padding-top:20px;" justify="space-between">
      <a-col span="5" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="5" class="form-label">分类</a-col>
          <a-col span="18">
            <a-select style="display:block" placeholder="请输入关键字" v-model="params.catagory"></a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="5" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="5" class="form-label">分公司</a-col>
          <a-col span="18">
            <a-select style="display:block" placeholder="请输入关键字" v-model="params.company"></a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="5" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="5" class="form-label">区域</a-col>
          <a-col span="18">
            <a-select style="display:block" placeholder="请输入关键字" v-model="params.area"></a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="3" style="margin-bottom:25px;">
        <a-row type="flex" align="top" justify="start">
          <a-col>
            <a-button type="primary" style="padding: 0 25px">查询</a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-divider></a-divider>-->
    <a-row :gutter="80" align="top" style="padding-top:20px;">
      <a-col v-if="tableData.length > 0">
        <a-table
          :pagination="false"
          :dataSource="tableData"
          :defaultExpandAllRows="true"
          :loading="loading"
          rowKey="id"
        >
          <a-table-column title="名称" data-index="name" width="30%" />
          <a-table-column title="备注" data-index="remark" width="60%" />
          <a-table-column
            title="操作"
            key="action"
            v-if="
              isAnyGranted([
                'office_setting.office_manager.list_edit',
                'office_setting.office_manager.list_create',
                'office_setting.office_manager.list_delete'
              ])
            "
          >
            <template slot-scope="text, record">
              <a-row type="flex" :gutter="10" justify="start">
                <a-col
                  v-if="
                    record.parent_id != 0 &&
                      isGranted('office_setting.office_manager.list_edit')
                  "
                >
                  <a @click.prevent="edit(record)">编辑</a>
                </a-col>
                <a-col
                  v-if="isGranted('office_setting.office_manager.list_create')"
                >
                  <a @click.prevent="add(record)">新增</a>
                </a-col>
                <a-col
                  v-if="
                    record.parent_id != 0 &&
                      isGranted('office_setting.office_manager.list_delete')
                  "
                >
                  <a @click.prevent="sureDel(record)">删除</a>
                </a-col>
              </a-row>
            </template>
          </a-table-column>
        </a-table>
      </a-col>
    </a-row>
    <edit-organization-modal
      ref="editModal"
      @ok="getData()"
    ></edit-organization-modal>
    <add-organization-modal
      ref="addModal"
      @ok="getData()"
    ></add-organization-modal>
  </div>
</template>

<script>
import EditOrganizationModal from "./edit-organization-modal";
import AddOrganizationModal from "./add-organization-modal";
import Api from "@/api";
import baseComponentVue from "../../../../components/base-component.vue";
// import { }from 'store'
export default {
  name: "Organization",
  extends: baseComponentVue,
  data() {
    return {
      loading: false,
      tableData: [],
      params: {
        catagory: "",
        company: "",
        area: ""
      }
    };
  },
  components: { EditOrganizationModal, AddOrganizationModal },
  computed: {},
  created() {
    this.getData();
  },
  mounted() {},
  methods: {
    async getData() {
      this.loading = true;
      let response = await Api.office.getTree();
      this.tableData = response.tree;
      this.loading = false;
    },
    edit(record) {
      let { editModal } = this.$refs;
      editModal.record = { ...record };
      editModal.show();
    },
    add(record) {
      let { addModal } = this.$refs;
      addModal.record = { ...record };
      addModal.show();
    },
    async sureDel(record) {
      const h = this.$createElement;
      if (record.children) {
        this.$info({
          title: "温馨提示",
          content: h("div", { style: { paddingTop: "20px" } }, [
            h("p", {}, "根目录下存在子目录，请先删除子目录"),
            h(
              "p",
              { style: { color: "red", fontSize: "16px" } },
              "当前目录不可删除"
            )
          ])
        });
      } else {
        let responese = await Api.office.enableDelete({ id: record.id });
        if (responese.result == 1) {
          //能删除
          this.$confirm({
            title: "温馨提示",
            content: h("div", { style: { paddingTop: "20px" } }, [
              h("p", "确定要删除该数据"),
              h("p", "删除后系统将不再显示该数据信息")
            ]),
            onOk: () => {
              return new Promise(async (resolve, reject) => {
                try {
                  await Api.office.delete({ id: record.id });
                  this.getData();
                } catch (e) {}
                resolve();
              });
            }
          });
        } else {
          this.$info({
            title: "温馨提示",
            content: h("div", { style: { paddingTop: "20px" } }, [
              h("p", {}, "该目录关联了员工数据，要删除，请先解除关联"),
              h(
                "p",
                { style: { color: "red", fontSize: "16px" } },
                "当前目录不可删除"
              )
            ])
          });
        }
      }
    },
    flat(node) {
      return node.reduce((arr, val, index) => {
        arr = arr.concat(val);
        if (Array.isArray(val.children)) {
          arr = arr.concat(this.flat(val.children));
        }
        return arr;
      }, []);
    }
  }
};
</script>

<style scoped lang="scss"></style>
